import { useQuery } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import useQSBuilder from '../../hooks/useQSBuilder';
import { IApplianceSelection } from '../../types/Appliance/Appliance';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useApplianceModels(
  manufacturerId?: string,
  typeId?: string
) {
  const { get } = useApiHelper();
  const buildQS = useQSBuilder();

  const applianceModels = useQuery({
    queryKey: applianceQueryKeys.models(manufacturerId),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceSelection>>(
        `/v1/hardware/models${manufacturerId !== undefined ? `/${manufacturerId}` : ''}${buildQS({ hardwareTypeId: typeId })}`
      ).then((res) => res.data.data),
  });

  return {
    applianceModels,
  };
}
